import { history } from './history';

const getCurrentAo = () => {
  try {
    const current = new URL(window.location.href);
    return current.searchParams.get('ao');
  } catch {
    return null;
  }
};

const buildTarget = (location, search) => {
  // location puede ser "/incidents" o "/incidents?x=1"
  const base = new URL(location, window.location.origin);

  // search extra (si te lo pasan) o el actual
  const extraSearch = search !== '' ? search : history.location.search;

  // normaliza extraSearch por si viene raro
  const extra = new URLSearchParams((extraSearch || '').replace(/^\?/, '').replace(/\?/g, '&'));

  // quita returnUrl siempre
  extra.delete('returnUrl');

  // preserva ao si existe en la url actual
  const ao = getCurrentAo();
  if (ao && !base.searchParams.has('ao')) {
    base.searchParams.set('ao', ao);
  }

  // añade el resto de params del extra (sin machacar los que ya estén en location)
  for (const [k, v] of extra.entries()) {
    if (!base.searchParams.has(k)) base.searchParams.set(k, v);
  }

  return base.pathname + (base.searchParams.toString() ? `?${base.searchParams.toString()}` : '') + base.hash;
};

export const forwardTo = (location, search = '') => {
  const target = buildTarget(location, search);
  history.push(target);
};

export const forwardToWithParams = (location, data, search = '') => {
  const target = buildTarget(location, search);
  history.push(target, data);
};

export default forwardTo;
